import React, { FC } from 'react';
import { PageTitle, PageLink } from '../../../../_mexablock/layout/core';
import { View } from './components/View';

const breadCrumbs: Array<PageLink> = [];

const ValidacionPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Validación</PageTitle>
      <View />
    </>
  );
};

export { ValidacionPage };
